import React from "react"
import { FormattedMessage } from "react-intl"
import Icon from "../../common/icon/icon.component.jsx"
import SideBar from "../../common/layout/sidebar.component.jsx"
import CustomTabs, { TabDetails } from "../../common/tab/CustomTabs"
import ProductEditForm from "../form/edit.component.jsx"

namespace TAB_KEY {
    export const PRODUCT_FORM = "product-form"
    export const SERIAL_NUMBER_LISTING = "serial-number-listing"
    export const INVENTORY = "inventory"
}
type TAB_KEY = typeof TAB_KEY[keyof typeof TAB_KEY]


const ProductCreatePage = () => {
    
    SideBar.activateMenu("product")

    const tabsMapping: Map<string, TabDetails> = new Map()
    
    tabsMapping.set(
        TAB_KEY.PRODUCT_FORM,
        {
            component: <ProductEditForm defaultState={{ type: "single" }} />,
            label: <FormattedMessage
                id="product.components.tab.product_label"
                defaultMessage="Product"
            />,
            disabled: false,
        }
    )

    tabsMapping.set(
        TAB_KEY.SERIAL_NUMBER_LISTING,
        {
            component: <></>,
            label: <>
                <FormattedMessage
                    id="product.components.tab.serial_numbers_label"
                    defaultMessage="Serial Numbers"
                />
                <Icon value={"info-circle"} className={"ml-1"} />
            </>,
            disabled: true,
            tooltipDetails: {
                id: TAB_KEY.SERIAL_NUMBER_LISTING,
                text: <FormattedMessage
                    id="product.components.tab.serial_number.tooltip.label"
                    defaultMessage="Create your product first and come back to add serial numbers."
                />,
                placement: "right"
            }
        }
    )

    return <CustomTabs
        tabsMapping={tabsMapping}
        defaultTabKey={TAB_KEY.PRODUCT_FORM}
    />
}
export default ProductCreatePage


// WEBPACK FOOTER //
// ./src/product/pages/ProductCreatePage.tsx